import { IS_DISK_ONLY } from 'reactApp/appHelpers/configHelpers';
import { publicInfoFileViewerToolbarEnabled } from 'reactApp/appHelpers/featuresHelpers/features/publicInfo';
import { MenuItemName } from 'reactApp/ui/ReactViewer/ViewerMenu/MoreMenuButton/MoreMenuButton.types';

import type { ViewerMenuProps } from '../ViewerMenu';

type Props = Pick<
    ViewerMenuProps,
    | 'onOpenParent'
    | 'onCopy'
    | 'enableFavorites'
    | 'onMove'
    | 'file'
    | 'onPrint'
    | 'onDelete'
    | 'allowPrinting'
    | 'onToggleFavorites'
    | 'onShowPublicInfo'
    | 'isAttachesEnabled'
    | 'onMail'
    | 'showDelete'
    | 'showCopy'
    | 'showMove'
    | 'showRename'
    | 'onRename'
    | 'showMailTo'
>;

export const getMoreItems = ({
    onOpenParent,
    onCopy,
    enableFavorites,
    onMove,
    file,
    onPrint,
    onDelete,
    allowPrinting,
    onToggleFavorites,
    onShowPublicInfo,
    isAttachesEnabled,
    onMail,
    onRename,
    showDelete,
    showCopy,
    showMove,
    showRename,
    showMailTo,
}: Props) => {
    if (!file) {
        return [];
    }

    const showMailToItem = showMailTo && isAttachesEnabled && !IS_DISK_ONLY;
    const isInFavorites = 'isInFavorites' in file && !!file.isInFavorites;
    const showPublicInfo = publicInfoFileViewerToolbarEnabled && Boolean('weblink' in file && file?.weblink);

    const baseItems = [
        { name: MenuItemName.OPEN_IN_PARENT, onClick: onOpenParent },
        ...(showCopy ? [{ name: MenuItemName.COPY, onClick: onCopy }] : []),
        ...(showRename
            ? [
                  {
                      name: MenuItemName.RENAME,
                      onClick: onRename,
                  },
              ]
            : []),
        ...(allowPrinting
            ? [
                  {
                      name: MenuItemName.PRINT,
                      onClick: () => {
                          onPrint(file);
                      },
                  },
              ]
            : []),
        ...(showMove ? [{ name: MenuItemName.MOVE, divider: !enableFavorites, onClick: onMove }] : []),
        ...(enableFavorites
            ? [
                  {
                      name: MenuItemName.FAVORITE, // тут какой бит нужен?
                      active: isInFavorites,
                      // tempexp_18663-next-line
                      divider: !showPublicInfo,
                      onClick: () => {
                          onToggleFavorites(file);
                      },
                  },
              ]
            : []),
        // tempexp_18663-start
        ...(showPublicInfo
            ? [
                  {
                      name: MenuItemName.SHOW_PUBLIC_INFO,
                      divider: true,
                      onClick: () => {
                          onShowPublicInfo(file);
                      },
                  },
              ]
            : []),
        // tempexp_18663-end
        ...(showMailToItem ? [{ name: MenuItemName.MAIL, divider: true, onClick: onMail }] : []),
        ...(showDelete
            ? [
                  {
                      name: MenuItemName.DELETE,
                      onClick: () => {
                          onDelete(file);
                      },
                  },
              ]
            : []),
    ];

    return [...baseItems];
};
